<template>
    <NuxtLink :to="linkUrl" class="cards-list-list__list-item cards-list-list__list-item--link">
        <h2 class="cards-list-list__list-item-title">{{ card.title }}</h2>
        <DSCFText class="cards-list-list__list-item-body" :content="card.text" />
        <span class="cards-list-list__link-label">{{ linkData.title }}</span>
        <DSFontIcon
            size="custom"
            class="cards-list-list__link-icon"
            code="arrow-right"
            icon-set="st1website"
        />
    </NuxtLink>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    card: {
        type: Object,
        required: true,
    },
});
const linkData = computed(() => props.card?.links[0] ?? {});
const linkUrl = computed(() => linkData.value?.url?.value ?? '');
</script>
